import { hrScrubVisibleText, hrUnitDisplayName } from '../../lib/hrUnitDisplay';
import type { NsoContentBlock } from './types';

/** Job satisfaction scores. The satisfaction page embeds the HR dashboard, which reads these rows. Cells stay as source text. */
export const HR_JOB_SATISFACTION_HEADERS = [
  'หน่วยงาน',
  'เป้าหมาย',
  '2566',
  '2567',
  '2568',
  '2569',
] as const;

export const HR_JOB_SATISFACTION_ROWS: readonly (readonly string[])[] = [
  ['OPD_MED', '75.00', '71.33', '72.38', '75.40', '72.30'],
  ['OPD_SxOrthoEENT', '75.00', '75.47', '79.51', '78.80', '79.30'],
  ['OPD_OBGYN', '75.00', '73.27', '79.95', '80.20', '78.70'],
  ['OPD_GENP', '75.00', '71.73', 'ไม่มีข้อมูล', '72.40', '67.70'],
  ['ERD', '75.00', '71.60', '71.38', '74.00', '76.20'],
  ['OR', '75.00', '71.03', '73.67', '74.60', '77.60'],
  ['G10', '75.00', '0.00', '74.11', '73.40', '67.80'],
  ['HD', '75.00', '78.27', '76.28', '74.80', '78.10'],
  ['BURN', '75.00', '0.00', '78.51', '78.80', 'รวมกับ SICU'],
  ['DR', '75.00', '61.20', '71.98', '75.60', '79.70'],
  ['NICU', '75.00', '68.70', '68.75', '75.80', '75.20'],
  ['PICU', '75.00', 'ยังไม่เปิด', 'ยังไม่เปิด', '81.00', 'ปิด'],
  ['MICU', '75.00', '75.57', '70.6', '78.40', '75.00'],
  ['CCU', '75.00', '0.00', '0.00', '78.60', '74.60'],
  ['SICU', '75.00', '74.80', '73.59', '72.40', '74.00'],
  ['18A', '75.00', '70.93', '75.82', '77.40', '78.80'],
  ['18B', '75.00', '74.73', '72.67', '74.00', '71.60'],
  ['18C', '75.00', 'ไม่ได้เก็บ', 'ไม่ได้เก็บ', '80.74', '79.30'],
  ['18D', '75.00', '62.77', '69.91', '72.60', '72.10'],
  ['19A', '75.00', '0.00', '0.00', '76.38', '77.30'],
  ['19B', '75.00', '74.23', '74.07', '77.80', '73.30'],
  ['19C', '75.00', '95.47', '72.64', 'ปิด', 'ปิด'],
  ['19D', '75.00', '73.70', '75.09', '77.00', '77.30'],
  ['20B', '75.00', '0.00', '0.00', '73.42', '80.20'],
  ['20C', '75.00', '0.00', '0.00', '79.3', '74.60'],
  ['21D', '75.00', '76.03', '74.27', '75.60', '75.90'],
  ['22A', '75.00', '73.90', '79.39', '77.80', '75.70'],
  ['22B', '75.00', '74.23', '74.59', '78.20', '78.20'],
  ['22C', '75.00', '75.10', '76.41', '75.00', '76.30'],
  ['22D', '75.00', '72.40', '73.75', '79.30', '76.90'],
  ['23A', '75.00', '68.00', '71.19', '78.40', '74.10'],
  ['24A', '75.00', '76.30', '81.47', '77.60', '80.70'],
  ['25A', '75.00', '72.13', '70.55', '75.40', '76.60'],
  ['25B', '75.00', '71.13', '77.07', '78.40', '72.80'],
  ['26A', '75.00', '81.67', 'ปิด', 'ปิด', 'ปิด'],
  ['26B', '75.00', '0.00', '80.88', '74.60', '80.20'],
  ['SW', '75.00', '68.17', '72.25', '79.00', '72.90'],
  ['CSSD', '75.00', '0.00', '82.72', '83.20', 'ไม่มีข้อมูล'],
  ['BLO_BNK', '75.00', '81.80', '75.78', '79.00', '75.60'],
  ['NSO', '75.00', '77.67', '76.24', '87.20', '82.50'],
  ['ผู้บริหาร', '75.00', '81.53', '87.57', '0.00', '88.30'],
  ['หอพัก', '75.00', '0.00', '70.92', '0.00', 'ไม่มีแล้ว'],
  ['ECC', '75.00', 'ไม่ได้เก็บ', 'ไม่ได้เก็บ', '83.20', '80.90'],
];

export function hrJobSatisfactionTableBlock(): Extract<NsoContentBlock, { type: 'dataTable' }> {
  return {
    type: 'dataTable',
    caption: 'ผลสำรวจความพึงพอใจในงาน ฝ่ายการพยาบาล ปี 2566–2569',
    headers: [...HR_JOB_SATISFACTION_HEADERS],
    rows: HR_JOB_SATISFACTION_ROWS.flatMap((row) => {
      const unitLabel = hrUnitDisplayName(row[0]);
      if (!unitLabel) return [];
      return [[unitLabel, ...row.slice(1).map((cell) => hrScrubVisibleText(cell))]];
    }),
  };
}
